import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditMessage } from '@efdigital/ll-admin-v2/components/programs/messages/edit-message.gts';
import type { ProgramsProgramCohortMessagesCategoryNewModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/category/new';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: ProgramsProgramCohortMessagesCategoryNewModel;
  };
}

const ProgramsProgramCohortMessagesCategoryNewTemplate: TemplateOnlyComponent<Signature> =
  <template>
    <div class="container-fluid py-4">
      <EditContext as |context|>
        <div class="row">
          <EditMessage
            @item={{@model.message}}
            @model={{@model}}
            @context={{context}}
            class="col-md-10 mx-auto"
          />
        </div>
      </EditContext>
    </div>
  </template>;

export default ProgramsProgramCohortMessagesCategoryNewTemplate;
